import React from 'react';
import { Form, Modal, Input } from 'antd';
import { MODAL_ADD, MODAL_EDIT } from '../../appConstants';

const FormItem = Form.Item;

const UserInputForm = Form.create()((props) => {
  const {
    form, modalVisible, modalType, handleModalVisible, handleSubmit,
  } = props;
  const text = modalType === MODAL_ADD ? 'Add' : 'Edit';

  const handleOk = () => {
    form.validateFields((err, fieldsValue) => {
      if (err) return;
      handleSubmit(fieldsValue);
      form.resetFields();
      handleModalVisible(modalType, false);
    });
  };

  const handleCancel = () => {
    form.resetFields();
    handleModalVisible(modalType, false);
  };

  return (
    <Modal
      title={`${text} User`}
      visible={modalVisible}
      onOk={handleOk}
      onCancel={handleCancel}
    >
      {modalType === MODAL_EDIT && <p style={{ textAlign: 'center' }}>Editing user: {props.editingUser.email}</p>}
      <FormItem labelCol={{ span: 5 }} wrapperCol={{ span: 15 }} label="email">
        {form.getFieldDecorator('email', {
          rules: [{
            required: true,
            message: 'Please input the user email',
          }, {
            type: 'email',
            message: 'Please input a valid email',
          }],
        })(<Input type="email" />)}
      </FormItem>
    </Modal>
  );
});

export default UserInputForm;



// WEBPACK FOOTER //
// ./src/components/UserInputForm/index.js